<template>
  <div>
    <div class="page-section callback-section">
      <div class="callback-section-img">
        <img src="/images/callback.webp"
             width="175"
             height="305"
             alt="Callback section">
      </div>
      <div class="callback-section-main">
        <div class="section-head">
          <div class="section-head-title">{{ $t('components.contactForm.title') }}</div>
        </div>
        <form ref="formRef" class="section-content" @submit.prevent="sendRequest">
          <div class="text-content">
            <p>
              {{ $t('components.contactForm.subTitle[0]') }}
              <span class="highlight-blue">{{ $t('components.contactForm.subTitle[1]') }}</span>{{
                $t('components.contactForm.subTitle[2]') }}
            </p>
            <p>
              {{ $t('components.contactForm.subTitle[3]') }}
            </p>
            <p>
              {{ $t('components.contactForm.subTitle[4]') }}
              <span class="highlight-blue">{{ $t('components.contactForm.subTitle[5]') }}</span>
            </p>
          </div>
          <div class="callback-form">
            <div class="form-main">
              <div class="form-item" :class="{ error: v$.phone.$errors.length }">
                <input name="phone" v-model="form.phone" class="textbox" :placeholder="$t('global.phoneNumber')" />
                <div class="input-errors" v-for="error of v$.phone.$errors" :key="error.$uid">
                  <div class="error-msg">{{ error.$message }}</div>
                </div>
              </div>
              <div class="form-item">
                <input v-model="form.email" type="text" name="email" class="textbox"
                  :placeholder="$t('global.email')" />
              </div>
              <div class="form-item" :class="{ error: v$.text.$errors.length }">
                <input name="text" v-model="form.text" class="textarea" :placeholder="$t('global.request')" />
                <div class="input-errors" v-for="error of v$.text.$errors" :key="error.$uid">
                  <div class="error-msg">{{ error.$message }}</div>
                </div>
              </div>
            </div>
            <div class="form-hint">
              {{ $t('components.contactForm.hint') }}
            </div>
            <div class="form-action">
              <button type="submit" class="button filled">
                {{ $t('components.contactForm.sendRequest') }}
              </button>
            </div>
          </div>
        </form>
      </div>
    </div>
    <Toast />
  </div>
</template>

<script setup lang="ts">
import { useVuelidate } from "@vuelidate/core";
import { required, email, helpers } from "@vuelidate/validators";

const toast = useToast();
const { locale, t } = useI18n()
const formRef = ref();

const { imgStartIndex, indexbatFormId } = defineProps({
  indexbatFormId: {
    type: Number,
    default: 69
  },
  imgStartIndex: {
    type: Number,
    default: 5
  }
})

const form = reactive({
  phone: "",
  email: "",
  text: "",
});

const phoneValidator = (value: string) =>
  /^\+?\(?\d{3}\)?[-\s.]?\d{3}[-\s.]?\d{4,6}$/.test(value);

const rules = {
  phone: {
    required: helpers.withMessage(() => t('validation.reqField'), required)
  },
  email: { email },
  text: {
    required: helpers.withMessage(() => t('validation.reqField'), required),
  },
};

const v$ = useVuelidate(rules, form);

const sendRequest = async () => {
  const isValid = await v$.value.$validate();
  if (isValid) {
    const formD = new FormData(formRef.value);
    formD.set('phone', `${formD.get('phone')} * locale: ${locale.value}`)
    formD.append("form_id", indexbatFormId.toString());

    await $fetch("https://loc.indexbat.com/api/survey", {
      method: "POST",
      body: formD,
      onResponse: ({ response }) => {
        if (response.status == 200) {
          toast.add({
            severity: "success",
            summary: t('statuses.success'),
            detail: t('notifications.success.applicationWasSend'),
            life: 3000,
          });
          for (let key in form) {
            v$.value[key].$model = "";
            v$.value[key].$dirty = false;
          }
        }
      },
    });
  }
};
</script>

<style lang="scss">
.form-item.error input {
  border: 1px solid red;
}

.input-errors {
  color: red;
  margin: 2px 0;
}
</style>
